document.addEventListener('instafeedAppLoaded', function () {
    console.log('Instafeed loaded — initializing Swiper');

    const container = document.querySelector('.instafeed-new-layout-container');
    const wrapper = container?.querySelector('.instafeed-new-layout-wrapper');
    const items = wrapper?.querySelectorAll('.instafeed-new-layout-item');

    if (!container || !wrapper || !items.length) {
        console.warn('Instafeed elements not found!');
        return;
    }

    const section = container.closest('.instafeed-wrapper');
    const prevButton = section?.querySelector('.swiper-btn-prev');
    const nextButton = section?.querySelector('.swiper-btn-next');
    const prevButtonMobile = section?.querySelector('.swiper-btn-prev-mobile');
    const nextButtonMobile = section?.querySelector('.swiper-btn-next-mobile');

    container.classList.add('swiper');
    wrapper.classList.add('swiper-wrapper');

    items.forEach((item) => item.classList.add('swiper-slide'));

    const swiperConfig = {
        loop: false,
        slidesPerView: 'auto',
        height: 'auto',
        centeredSlides: false,
        spaceBetween: 0,
        slidesPerGroupAuto: true,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,

        breakpoints: {
            1440: {
                slidesOffsetAfter: 136,
                slidesOffsetBefore: 136,
            },
        },
    };

    const swiper = new Swiper(container, swiperConfig);

    if (prevButton) {
        prevButton.addEventListener('click', () => {
            swiper.slidePrev();
            setTimeout(() => updateButtonStates(), 0);
        });
    }
    if (nextButton) {
        nextButton.addEventListener('click', () => {
            swiper.slideNext();
            setTimeout(() => updateButtonStates(), 0);
        });
    }

    // Mobile buttons
    if (prevButtonMobile) {
        prevButtonMobile.addEventListener('click', () => {
            swiper.slidePrev();
            setTimeout(() => updateButtonStates(), 0);
        });
    }
    if (nextButtonMobile) {
        nextButtonMobile.addEventListener('click', () => {
            swiper.slideNext();
            setTimeout(() => updateButtonStates(), 0);
        });
    }

    const updateButtonStates = () => {
        const isBeginning = swiper.isBeginning;
        const isEnd = swiper.isEnd;

        swiper.updateSize();

        if (prevButton) prevButton.setAttribute('aria-disabled', isBeginning);
        if (nextButton) nextButton.setAttribute('aria-disabled', isEnd);
        if (prevButtonMobile) prevButtonMobile.setAttribute('aria-disabled', isBeginning);
        if (nextButtonMobile) nextButtonMobile.setAttribute('aria-disabled', isEnd);
    };

    swiper.on('slideChange', updateButtonStates);
    swiper.on('slideChangeTransitionEnd', updateButtonStates);
    updateButtonStates();

    console.log('Swiper initialized', swiper);
});
